"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

exports.__esModule = true;
exports.computePickupDate = exports.computeDeliveryDate = exports.getAppId = exports.getUserInfo = exports.decodeUserToken = exports.getDeviceId = exports.inBrowser = exports.getFormattedCurrency = void 0;

var _uuid = require("uuid");

var _moment = _interopRequireDefault(require("moment"));

var _provinces = _interopRequireDefault(require("./provinces.json"));

var _jsonwebtoken = require("jsonwebtoken");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getFormattedCurrency = function getFormattedCurrency(value) {
  var formattedNumber = (Math.round(value * 100) / 100).toFixed(2);
  var price = formattedNumber.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  return price;
};

exports.getFormattedCurrency = getFormattedCurrency;
var inBrowser = !!(typeof window !== "undefined" && window.document && window.document.createElement);
exports.inBrowser = inBrowser;

var getDeviceId = function getDeviceId() {
  var deviceStorageKey = "acehardwareph-deviceid";
  var deviceId = undefined;
  return new Promise(function (resolveId) {
    deviceId = inBrowser ? localStorage.getItem(deviceStorageKey) : '';

    if (inBrowser && (deviceId === undefined || deviceId === null)) {
      deviceId = localStorage.setItem(deviceStorageKey, (0, _uuid.v4)());
    }

    if (deviceId) {
      resolveId("device-" + deviceId);
    }
  });
};

exports.getDeviceId = getDeviceId;

var getUserInfo = function getUserInfo() {
  return inBrowser ? decodeUserToken(localStorage.getItem('access-token')) : {};
};

exports.getUserInfo = getUserInfo;

var getAppId = function getAppId() {
  var accessToken = inBrowser ? decodeToken(localStorage.getItem('access-token')) : {};
  return accessToken.appId;
};

exports.getAppId = getAppId;

var decodeToken = function decodeToken(token) {
  try {
    return (0, _jsonwebtoken.decode)(token);
  } catch (e) {
    console.log(e);
    return null;
  }
};

var decodeUserToken = function decodeUserToken(token) {
  try {
    if (token) {
      var _decode = (0, _jsonwebtoken.decode)(token),
          userInfo = _decode.userInfo;

      return userInfo;
    }

    return null;
  } catch (e) {
    console.log(e);
    return null;
  }
};

exports.decodeUserToken = decodeUserToken;

var getIslandGroup = function getIslandGroup(cityAddress, isPickup) {
  var islandGroup = "";
  var splitAddress = cityAddress.replace(/\s\s+/g, " ").toUpperCase().split(", ");
  var provinceName = isPickup ? splitAddress[splitAddress.length - 2] : splitAddress[splitAddress.length - 1];

  var province = _provinces["default"].PROVINCE_MAP[provinceName.toUpperCase()];

  var region = province ? province.region : "";
  Object.keys(_provinces["default"].ISLAND_MAP).forEach(function (key) {
    if (_provinces["default"].ISLAND_MAP[key].indexOf(region) > -1) islandGroup = key;
  });
  return islandGroup;
};

var addWorkDay = function addWorkDay(date, days) {
  date = (0, _moment["default"])(date);

  while (days > 0) {
    date = date.add(1, "days");

    if (date.isoWeekday() !== 7) {
      days -= 1;
    }
  }

  return date;
};

var computeDeliveryDate = function computeDeliveryDate(checkoutCart) {
  var islandGroup = getIslandGroup(checkoutCart.address.cityAddress, checkoutCart.isPickup);
  var confirmedDate = checkoutCart.history.filter(function (el) {
    return el.status === "CONFIRMED";
  })[0] || {};
  var daysFrom, daysTo;
  var dayStart, dayEnd;

  switch (islandGroup) {
    case "METRO MANILA":
      {
        daysFrom = 3;
        daysTo = 5;
        break;
      }

    case "LUZON":
      {
        daysFrom = 5;
        daysTo = 7;
        break;
      }

    case "VISAYAS":
      {
        daysFrom = 7;
        daysTo = 9;
        break;
      }

    case "MINDANAO":
      {
        daysFrom = 9;
        daysTo = 11;
        break;
      }

    default:
      {
        daysFrom = 9;
        daysTo = 11;
        break;
      }
  }

  dayStart = addWorkDay((0, _moment["default"])(confirmedDate.date), daysFrom);
  dayEnd = addWorkDay((0, _moment["default"])(dayStart), daysTo - daysFrom);
  return dayStart.format("MMMM D") + " - " + dayEnd.format("MMMM D, YYYY");
};

exports.computeDeliveryDate = computeDeliveryDate;

var computePickupDate = function computePickupDate(checkoutCart) {
  var confirmedDate = checkoutCart.history.filter(function (el) {
    return el.status === "CONFIRMED";
  })[0] || {};
  var pickupConfirmedDate = (0, _moment["default"])(confirmedDate.date);
  var pickupCutOffDate = (0, _moment["default"])(new Date());
  pickupCutOffDate.set({
    hour: 13,
    minute: 0,
    second: 0,
    millisecond: 0
  });
  var today = (0, _moment["default"])();

  if (pickupConfirmedDate.isBefore(pickupCutOffDate)) {
    return today.format("MMMM D, YYYY");
  } else {
    return today.add(1, 'd').format("MMMM D, YYYY");
  }
};

exports.computePickupDate = computePickupDate;